import { createStore } from 'vuex';

const store = createStore({
    state(){
        return{
            token: localStorage.getItem('authToken'),
            // Insurer toasts visible right now (OperationsModule); the global
            // chat bubble dodges to the bottom-left while any are on screen.
            insurerToastCount: 0,
        };
    },
    mutations: {
        setToken(state, token){
            state.token = token;
        },
        setInsurerToastCount(state, count){
            state.insurerToastCount = count;
        },
    },
    actions: {

    },
    getters: {
        isAuthenticated(state){
            return !!state.token;
        }, 
    },
    modules: {

    }
});

export default store;